(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/constants/constants.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/constants/constants.js');
'use strict';

var _svs$core$config$data;
const isNativeApp = Boolean((_svs$core$config$data = svs.core.config.data) === null || _svs$core$config$data === void 0 || (_svs$core$config$data = _svs$core$config$data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.isNativeApp);
const URL = {
  EXCLUSION: 'https://www.spelpaus.se',
  NATIONAL: 'https://spelpaus.se/?scos=true',
  LOG_IN: "".concat(svs.core.urlMapping.get('loginHome'), "?returnUrl=").concat(encodeURI(svs.core.urlMapping.get('gamingResponsibilityPause'))),
  READ_MORE: '#readMore',
  CUSTOMER_SERVICE_HOME: svs.core.urlMapping.get('customerServiceHome')
};
const DOCS = {
  PERSONAL_POLICY: "/dokument/".concat(svs.self_exclusion_react.data.personalPolicyDoc),
  PERSONAL_INFORMATION: "/dokument/".concat(svs.self_exclusion_react.data.personalInformationDoc)
};
const DOCS_NATIVE = {
  PERSONAL_POLICY: "".concat(svs.self_exclusion_react.data.getCMSUrl, " ").concat(svs.self_exclusion_react.data.personalPolicyDoc),
  PERSONAL_INFORMATION: "".concat(svs.self_exclusion_react.data.getCMSUrl, " ").concat(svs.self_exclusion_react.data.personalInformationDoc)
};
const NATIONAL = 'nationell avstängning';
const PHONE = 'tel:0770-11-11-11';
const gamesLabelText = 'Välj vilket eller vilka spel du vill pausa dig från';
const periodsLabelText = 'Välj hur lång paus du vill ta';
const CONSTANTS = {
  URL,
  DOCS,
  DOCS_NATIVE,
  NATIONAL,
  PHONE,
  isNativeApp,
  gamesLabelText,
  periodsLabelText
};
svs.selfExclusion.Constants = CONSTANTS;

 })(window);